<mat-dialog-content class="action-dialog">
  <h2 class="dialog-title-space">Locatiebepaling project #{{ projectId }}</h2>

  <mat-spinner
    *ngIf="!init"
    style="margin: auto"
    color="primary"
    diameter="24"
  ></mat-spinner>

  <div *ngIf="init">
    <div
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.type ===
          'BaseProject' && contactDisplays.length > 0
      "
      class="small-upper-space"
    >
      <div class="form-title">
        <div class="form-title-text">Contacten</div>
      </div>
      <ul class="inpress-ul">
        <li *ngFor="let contact of contactDisplays">
          <span>{{ contact.company }}</span>
          <span> / {{ contact.fullName }}</span>
          <span *ngIf="contact.phoneNumber?.length > 0">
            /
            <a class="click-link" href="tel:{{ contact.phoneNumber }}">{{
              contact.phoneNumber
            }}</a></span
          >
          <span *ngIf="contact.mobileNumber?.length > 0">
            /
            <a class="click-link" href="tel:{{ contact.mobileNumber }}">{{
              contact.mobileNumber
            }}</a></span
          >
          <span *ngIf="contact.email?.length > 0">
            /
            <a
              class="click-link"
              href="{{
                contact.email
                  | mailSubjectBodyLink
                    : projectId
                    : contact.firstName
                    : locationVerificationProjectWideDisplay.subProject
                        .projectPlacement?.address?.line1
                    : locationVerificationProjectWideDisplay.subProject
                        .projectPlacement?.address?.postalCode
                    : locationVerificationProjectWideDisplay.subProject
                        .projectPlacement?.address?.city
              }}"
              >{{ contact.email }}</a
            ></span
          >
        </li>
      </ul>
    </div>
    <div
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.type !== 'BaseProject'
      "
    >
      <div class="form-title">
        <div class="form-title-text">Samenvatting</div>
      </div>
      <adjustment-project-summary
        [subproject]="locationVerificationProjectWideDisplay.subProject"
        [project]="locationVerificationProjectWideDisplay.project"
      ></adjustment-project-summary>
    </div>
    <div
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          ?.siteVisit
      "
      class="small-upper-space"
    >
      <div class="form-title">
        <div class="form-title-text">Werfbezoek</div>
      </div>
      <div>
        <span class="strong">Toegewezen aan: </span>
        <span>{{
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .employee?.user?.firstName
            | personName
              : locationVerificationProjectWideDisplay.subProject
                  .projectPlacement.employee?.user?.lastName
            | or
        }}</span>
      </div>
      <div>
        <span class="strong">Uiterste datum: </span>
        <span>{{
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .deadlineSiteVisit | formatDate : '-'
        }}</span>
      </div>
      <div class="preserve-line-break">
        <span class="strong">Feedback: </span>
        <span>{{
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .siteVisitFeedback | or
        }}</span>
      </div>
    </div>
    <div
      *ngIf="locationVerificationProjectWideDisplay.subProject.needsQuotation"
      class="small-upper-space"
    >
      <div class="form-title">
        <div class="form-title-text">Offerte</div>
      </div>
      <div>
        <div class="d-flex">
          <div class="strong">Prijs (excl. BTW):</div>
          <div
            *ngIf="
              locationVerificationProjectWideDisplay.subProject
                .projectInvoices == null &&
                locationVerificationProjectWideDisplay.subProject
                  .projectInvoices.length === 0;
              else displayPrices
            "
            class="flexer small-left-space"
          >
            -
          </div>
          <ng-template #displayPrices>
            <ul class="inpress-ul flexer small-left-space no-bottom-margin">
              <li
                *ngFor="
                  let invoice of locationVerificationProjectWideDisplay
                    .subProject.projectInvoices
                "
              >
                <span class="strong">{{ invoice.company?.regularName }}: </span>
                <span
                  >€
                  {{ invoice.displayPrice | asFormatDecimal : true : 2 }}</span
                >
              </li>
            </ul>
          </ng-template>
        </div>
        <div>
          <span class="strong">Toegewezen aan: </span>
          <span>{{
            locationVerificationProjectWideDisplay.subProject.quotationHandler
              ?.user?.firstName
              | personName
                : locationVerificationProjectWideDisplay.subProject
                    .quotationHandler?.user?.lastName
              | or
          }}</span>
        </div>
        <div>
          <span class="strong">{{ quotationDateLabel }}: </span>
          <span>{{ quotationDate | formatDate : '-' }}</span>
        </div>
      </div>
    </div>
    <div
      class="sub-project-banner-container upper-space dialog-title-space banner-bottom-padding"
      [ngClass]="bannerContainerClass"
    >
      <div class="sub-project-banner flexer">
        <span class="sub-project-banner-title center-banner-title">{{
          bannerTitle
        }}</span>
      </div>
    </div>
    <ng-container
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.type !==
          'BaseProject' &&
        locationVerificationProjectWideDisplay.subProject.withPlacement
      "
    >
      <div class="form-title">
        <div class="form-title-text">Locatie en plaatsing</div>
      </div>
      <mat-card
        class="mat-elevation-z0 overflow-hidden vertically-center upper-space"
      >
        <ex-edit-adjustment
          [subproject]="locationVerificationProjectWideDisplay.subProject"
          [project]="locationVerificationProjectWideDisplay.project"
          [showClientStrings]="false"
        ></ex-edit-adjustment>
      </mat-card>
      <mat-card class="mat-elevation-z0 internal-form">
        <general-internal-adjustment
          *ngIf="
            locationVerificationProjectWideDisplay.subProject.type !== 'Repo'
          "
          [adjustment]="locationVerificationProjectWideDisplay.subProject"
          [project]="locationVerificationProjectWideDisplay.project"
        >
        </general-internal-adjustment>

        <textarea-input
          *ngIf="
            locationVerificationProjectWideDisplay.subProject.type !== 'Repo' &&
            locationVerificationProjectWideDisplay.subProject
              .projectPlacement != null
          "
          [title]="'Hoe plaatsen'"
          [placeholder]="'Geef hier instructies voor de plaatsing'"
          (answer)="placeInstructionsChanged($event)"
          [initContent]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .placeInstructions
          "
        >
        </textarea-input>
        <file-picker
          [title]="'Ontwerp'"
          [inputProjectPlacement]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
          "
          [formSection]="'adjustmentDesign'"
        >
        </file-picker>
        <file-picker
          [title]="'Ontwerp + impressie'"
          [inputProjectPlacement]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
          "
          [formSection]="'adjustmentInternal'"
        >
        </file-picker>

        <div class="external-supplier-margin">
          <external-supplier
            [externalSupplierAware]="
              locationVerificationProjectWideDisplay.subProject
            "
            [employeeChoices]="externalSupplierChoices"
          ></external-supplier>
        </div>

        <yes-no
          [title]="'Mag het Inpress logo toegevoegd worden?'"
          [neverShowExtraInstructions]="true"
          [extraInstructions]="''"
          [value]="
            locationVerificationProjectWideDisplay.subProject.inpressLogo
          "
          [inputText]="''"
          [nullIsFalse]="false"
          [nullable]="true"
          (answer)="inpressLogoChanged($event)"
        ></yes-no>

        <yes-no
          [title]="'Mag het Immoscoop logo toegevoegd worden?'"
          [neverShowExtraInstructions]="true"
          [extraInstructions]="''"
          [value]="
            locationVerificationProjectWideDisplay.subProject.immoscoopLogo
          "
          [inputText]="''"
          [nullIsFalse]="false"
          [nullable]="true"
          (answer)="immoscoopLogoChanged($event)"
        ></yes-no>

        <yes-no
          [title]="'Mag het Spotto logo toegevoegd worden?'"
          [neverShowExtraInstructions]="true"
          [extraInstructions]="''"
          [value]="locationVerificationProjectWideDisplay.subProject.spottoLogo"
          [inputText]="''"
          [nullIsFalse]="false"
          [nullable]="true"
          (answer)="spottoLogoChanged($event)"
        ></yes-no>

        <ng-container
          *ngIf="
            locationVerificationProjectWideDisplay.subProject.type ===
            'SoldRented'
          "
        >
          <div class="title">Afstand vanop de grond tot bovenkant sticker</div>
          <div class="first-form-field">
            <mat-form-field appearance="outline">
              <mat-label>Meter</mat-label>
              <input
                type="number"
                placeholder="Meter"
                matInput
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="
                  locationVerificationProjectWideDisplay.subProject
                    .projectPlacement.soldRentedStickerWorkHeight
                "
                (ngModelChange)="soldRentedStickerWorkHeightChange($event)"
                required
              />
            </mat-form-field>
          </div>
        </ng-container>

        <div class="title">Ladder/stelling/hoogwerker</div>
        <mat-form-field class="first-form-field" appearance="outline">
          <mat-select
            matInput
            placeholder="Kies gereedschap"
            [(ngModel)]="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .heightEquipment
            "
            [ngModelOptions]="{ standalone: true }"
            [compareWith]="compareEnums"
            required
          >
            <mat-option
              *ngFor="let equipment of heightEquipmentOptions"
              [value]="equipment"
            >
              {{ equipment.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <yes-no
          [title]="'Zijn er obstakels'"
          [showExtraInstructionsOn]="'Ja'"
          [nullIsFalse]="false"
          [nullable]="true"
          [value]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .obstaclesPresent
          "
          [inputText]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .obstaclesInfo
          "
          [extraInstructions]="'Geef meer informatie aub'"
          (answer)="obstaclesPresentChange($event)"
          (answeredText)="obstaclesInfoTextChange($event)"
        >
        </yes-no>

        <div class="d-flex">
          <div>
            <div class="form-sub-title">Installateur(s)</div>

            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                multiple
                placeholder="Maak een keuze"
                required
                [(ngModel)]="
                  locationVerificationProjectWideDisplay.subProject
                    .projectPlacement.placers
                "
                name="placer"
                (ngModelChange)="placerChange()"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of placerChoices"
                  [value]="option"
                >
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="left-space">
            <div class="form-sub-title">Plaatsingsdatum</div>
            <mat-form-field appearance="outline">
              <input
                #confirmedPlacementDateInput
                matInput
                [matDatepicker]="confirmedPlacementPicker"
                placeholder="Selecteer een datum"
                [value]="
                  locationVerificationProjectWideDisplay.subProject
                    .currentConfirmedPlacementDate
                "
                [disabled]="
                  locationVerificationProjectWideDisplay.subProject
                    .projectPlacement.currentPlacementDateConfirmed
                "
                name="confirmedPlacementDateDate"
                (dateChange)="currentConfirmedPlacementDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="confirmedPlacementPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #confirmedPlacementPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="align-placement-date-confirmed-checkbox">
            <checkbox
              [checked]="
                locationVerificationProjectWideDisplay.subProject
                  .projectPlacement.currentPlacementDateConfirmed
              "
              [text]="'Datum vastzetten'"
              [isDisabled]="
                locationVerificationProjectWideDisplay.subProject
                  .currentConfirmedPlacementDate == null
              "
              (answer)="currentPlacementDateConfirmedChange($event)"
            ></checkbox>
          </div>

          <div class="left-space">
            <time-budget-picker
              [hourBudget]="
                locationVerificationProjectWideDisplay.subProject
                  .projectPlacement.installerHourBudget
              "
              [minuteBudget]="
                locationVerificationProjectWideDisplay.subProject
                  .projectPlacement.installerMinuteBudget
              "
              (hourChange)="installerHourBudgetChange($event)"
              (minuteChange)="installerMinuteBudgetChange($event)"
            ></time-budget-picker>
          </div>
        </div>
        <div *ngIf="adjustmentPlacerNames?.length > 0">
          <span class="strong">Gekozen installateurs: </span>
          <span>{{ adjustmentPlacerNames }}</span>
        </div>
      </mat-card>
    </ng-container>
    <ng-container
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.type ===
          'BaseProject' &&
        locationVerificationProjectWideDisplay.project.products?.length > 0
      "
    >
      <div class="form-title small-upper-space">
        <div class="form-title-text">Producten</div>
      </div>
      <location-verification-product-display
        *ngFor="
          let product of locationVerificationProjectWideDisplay.project
            .products;
          let index = index;
          trackBy: trackById
        "
        [product]="product"
        [index]="index"
        [multipleProducts]="multipleProducts"
        [locationVerificationProjectWideDisplay]="
          locationVerificationProjectWideDisplay
        "
        [withPlacement]="
          locationVerificationProjectWideDisplay.subProject.withPlacement
        "
        (locationAssetsUpdated)="preprocessAssets()"
      ></location-verification-product-display>
    </ng-container>
    <div class="upper-space">
      <textarea-input
        [placeholder]="''"
        [initContent]="
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .locationVerificationExtraInfo
        "
        (answer)="locationVerificationExtraInfoChanged($event)"
      >
      </textarea-input>
    </div>
    <div class="checkbox-margin">
      <span class="section-title">Locatiebepaling in orde</span>
    </div>
    <checkbox
      [text]="'Locatiebepaling in orde'"
      [checked]="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerified
      "
      [trueVerification]="locationVerifiedValidationCallback"
      (answer)="locationVerifiedChanged($event)"
    ></checkbox>
    <logged-action-display
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerifiedRegistration != null
      "
      [inputLoggedAction]="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerifiedRegistration
      "
    ></logged-action-display>
    <checkbox
      [text]="'Nagekeken door Jan/Yannick'"
      [checked]="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerificationCheckedByExpert
      "
      [isDisabled]="
        !locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerified
      "
      (answer)="locationVerificationCheckedByExpertChanged($event)"
    ></checkbox>
    <logged-action-display
      *ngIf="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerificationCheckedByExpertRegistration != null
      "
      [inputLoggedAction]="
        locationVerificationProjectWideDisplay.subProject.projectPlacement
          .locationVerificationCheckedByExpertRegistration
      "
    ></logged-action-display>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <mat-spinner *ngIf="submitting" color="primary" diameter="24"></mat-spinner>
  <div *ngIf="!submitting">
    <button type="button" (click)="closeDialog()" class="btn btn-main btn-back">
      Annuleer
    </button>
    <button
      type="button"
      (click)="save()"
      mat-button
      class="button"
      id="btnSave"
      [disabled]="submitting"
    >
      Opslaan
    </button>
  </div>
</mat-dialog-actions>
